import {
	InputModelPathUtil,
	ViewModelPathUtil,
} from "@/components/features/_model/converter/input-model-to-view-model/mapper/util";
import type { AutoGeneratorForFormModel } from "@/components/features/_model/types";

/**
 *
 * @description 新規に編集されたデータを ViewModel にマッピングする
 *
 * @todo テストを追加。ただし、上位でブラックボックステストとして担保はしている。
 *
 * @param viewModel
 * @param excludeKeys
 * @param currentInput
 * @param defaultInput
 *
 * @returns ViewModel
 */
export const editedDataMapper = <I, E, Q>(
	viewModel: AutoGeneratorForFormModel<I, E, Q>["ViewModel"],
	excludeKeys: Array<string>,
	currentInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
	defaultInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
): AutoGeneratorForFormModel<I, E, Q>["ViewModel"] => {
	// InputModel の Node までの path を取得
	const currentInputPaths = InputModelPathUtil.generateNodePaths(currentInput);

	// 新たに編集されたデータのパスを取得
	const editedPaths: Array<string | number>[] = [];
	for (const path of currentInputPaths) {
		// InputModel の Node を取得
		const currentData = InputModelPathUtil.getObjectWithPath(path, currentInput);
		const defaultData = InputModelPathUtil.getObjectWithPath(path, defaultInput);

		if (currentData === defaultData) continue;

		// データが異なっていた場合
		editedPaths.push(path);
	}

	for (const editedPath of editedPaths) {
		// InputModel の path を ViewModel の path に変換
		const viewModelPath = ViewModelPathUtil.pathConverter(editedPath, excludeKeys);
		// 差分のある Node が除外対象の場合はスキップ
		if (viewModelPath.length === 0) continue;

		// ViewModel の Node を取得
		const editedObject = ViewModelPathUtil.getObjectWithViewModelPath(viewModelPath, viewModel);
		// Node がなければスキップ
		if (editedObject === undefined || editedObject === null) continue;

		if (Object.prototype.hasOwnProperty.call(editedObject, "isEdited")) {
			// Node に 'isEdited' があれば代入
			editedObject.isEdited = true;
		}

		// ViewModel の Node から見た 親 Node の path を取得
		const parentPaths = ViewModelPathUtil.getViewModelParentPaths(viewModelPath);
		for (const parentPath of parentPaths) {
			// parentPath に合致する ViewModel の Node を取得
			const parentObject = ViewModelPathUtil.getObjectWithViewModelPath(parentPath, viewModel);
			// Node がなければスキップ
			if (parentObject === undefined || parentObject === null) continue;
			if (Object.prototype.hasOwnProperty.call(parentObject, "isEdited")) {
				// Node に 'isEdited' があれば代入
				parentObject.isEdited = true;
			}
		}
	}
	return viewModel;
};
